import React, { useState,useEffect} from 'react';
import { Table ,Space} from 'antd';
import moment, { Moment } from 'moment';
import request from '../../../../request';
import SPContentWrap from "components/carRental/base/SPContentWrap";
import {
  API_VEHICLE_OCCUPY_SUMMARY_LIST,
  API_STORE_LIST_SELECT
} from '../../../../hooks/carRental/_';
import emiter, {
	EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH,
	_EVENTS, EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH_FROM_SEARCH
} from '../../../../events';


const getBgColor = (type?: any) => {
	switch (type) {
		case 0:
			return '#D6E4FF';
		case 1:
			return '#FFE0CC';
	}
};

const getTimeRange = () => {
		let startTime = moment().startOf('day');
    let endTime = moment().endOf('day');
		let result = [];
		while (startTime <= endTime) {
			//年月日时分秒
			result.push(startTime.format('HH:mm'));
			startTime = startTime.clone().add(15, 'minutes');
		}
		return result;
};

const getType = (data: any) => {
  if (data?.order_occupied > 0 && data?.temporary_occupied == 0) {
    return 1
  } else if (data?.order_occupied == 0 && data?.temporary_occupied > 0) {
    return 0
  } else if (data?.order_occupied > 0 && data?.temporary_occupied > 0) {
    return 2
  }
}

const generateColumns = () => {
  const columns:any = [
    {
      title: '日期',
      dataIndex: 'date',
      key: 'date',
      fixed: 'left',
      render: (text: string, record: any) => moment(record.date *1000).format('YYYY-MM-DD'),
    },
  ];

  let timeRange = getTimeRange()

  columns.push(
    ...timeRange.map((time: string) => {
				return {
					title: time,
					dataIndex: time,
					key: time,
					width: 20,
					align: 'center',
					render: (text: any, record: any) => {
						return (
							<div >
                {record.one_day?.map((item: any) => {
                  if (moment(item.begin * 1000).format('HH:mm') === time) {
                    return (
                      <div
                        style={{
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          bottom: 0,
                          background: getBgColor(getType(item)),
                          zIndex: 1,
                          width: '98%',
                          height: '98%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          textAlign: 'center',
                        }}
                      >
                        {item?.amount - item?.order_occupied - item?.temporary_occupied + '/' + item?.amount}
                      </div>
                    );
                  }
								})}
							</div>
						);
					},
				};
			})
  )

  return columns;
};


interface Props {
  enums?: any
}

const SPSummaryTable: React.FC<Props> = (props) => {
  const { enums } = props;
  const columns = generateColumns();
  const [data, setData] = useState<any>([]);

  const getStoreCode = () => {
		request({
			url: API_STORE_LIST_SELECT,
			method: 'GET',
		}).then((res: any) => {
			if (!res.data || !res.data.length) {
				return;
			}
      delete res.data[0].store_name;
			loadData(res.data[0]);
		});
	};

	const loadData = (data?: any) => {
		request({
			url: API_VEHICLE_OCCUPY_SUMMARY_LIST,
			method: 'GET',
			params: {
				store_code: data.store_code,
        vehicle_code: data.vehicle_code,
        date: moment(data.date).unix(),
			},
		}).then((res: any) => {
			if (res.data!== null && res.data.list.length) {
				setData(res.data.list);
			} else {
				setData([]);
			}
		}).catch((err: any) => {
			setData([]);
		})
	};

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH, loadData)
    getStoreCode()
	  return () => {
		  emiter.removeAllListeners(EVENT_CARRENTAL_VEHICLE_OCCUPSUMMARY_SEARCH)
	  }
  }, [])

  return (
    <>
      <SPContentWrap className='page-action-bar'>
				<Space>
					{enums.stock_use_type	?.map((item: any) => {
						return (
							<div
								style={{
									height: 30,
									background: getBgColor(item.key),
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									width: 100,
									borderRadius: 5,
								}}
							>
								{item.value}
							</div>
						);
					})}
				</Space>
			</SPContentWrap>
      <Table columns={columns} dataSource={data} pagination={false} scroll={{ x: 'max-content' }} />
    </>);
};

export default SPSummaryTable;
